export const common = {
  common: {
    firstLoginHeading: 'Anmeldung erfolgreich!',
    firstLoginGreeting: 'Willkommen bei ',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    remove: 'Entfernen',
    edit: 'Bearbeiten',
    restore: 'Wiederherstellen',
    back: 'Zurück',
    next: 'Weiter',
    submit: 'Absenden',
    continue: 'Weiter',
    save: 'Speichern',
    done: 'Fertig',
    home: 'Start',
    noData: 'Keine Daten.',
    confirm: 'Bestätigen',
    more: 'mehr',
    close: 'Schließen',
    loading: 'Laden',
    loaded: 'geladen',
    menu: 'Menü',
    reset: 'Zurücksetzen',
    search: 'Suche',
    add: 'Hinzufügen',
    create: 'Erstellen',
    success: 'erfolgreich',
    error: 'Fehler',
    warning: 'Warnung',
    move: 'verschieben',
    update: 'umbennen',
    readArticle: 'Beitrag lesen',
    toFaqs: "Zu den FAQ's",
    salutation: {
      female: 'Frau',
      male: 'Herr',
      diverse: 'Divers',
    },
  },
  pageMetaResolver: {
    category: {
      title: '{{count}} result for {{query}}',
      title_plural: '{{count}} results for {{query}}',
    },
    checkout: {
      title: 'Checkout',
    },
    search: {
      title: '{{count}} result for "{{query}}"',
      title_plural: '{{count}} results for "{{query}}"',
      findProductTitle: '{{count}} result for coupon "{{coupon}}"',
      findProductTitle_plural: '{{count}} results for coupon "{{coupon}}"',
      default_title: 'All products',
    },
    product: {
      description: '{{description}}',
      heading: '{{heading}}',
      title: '{{title}}',
    },
  },
  spinner: {
    loading: 'Laden...',
  },
  navigation: {
    shopAll: 'Alle kaufen {{ navNode}} >',
  },
  searchBox: {
    placeholder: 'Search here...',
    ariaLabelInput: 'Search here...',
    ariaLabelSuggestions: 'typing suggestions',
    ariaLabelProducts: 'product results',
    initialDescription:
      'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
    suggestionsResult: '{{ count }} suggestion and ',
    suggestionsResult_plural: '{{ count }} suggestions and ',
    productsResult: '{{ count }} product is available.',
    productsResult_plural: '{{ count }} products are available.',
    resetLabel: 'Reset Search',
    help: {
      insufficientChars: 'Please type more characters',
      noMatch: 'We could not find any results',
      exactMatch: '{{ term }}',
      empty: 'Ask us anything',
    },
  },
  sorting: {
    date: 'Date',
    orderNumber: 'Order Number',
    rma: 'Return Number',
    replenishmentNumber: 'Replenishment Number',
    nextOrderDate: 'Next Order Date',
  },
  httpHandlers: {
    badGateway: 'Es ist ein Serverfehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
    badRequestPleaseLoginAgain:
      'Das hat leider nicht funktioniert. Bitte prüfe, ob du die richtige E-Mail-Adresse und das richtige Passwort verwendest.',
    badRequestOldPasswordIncorrect: 'Altes Passwort falsch.',
    badRequestGuestDuplicateEmail:
      '{{ errorMessage }} E-Mail existiert bereits. Bitte melden Sie sich mit einer anderen E-Mail-Adresse an, um sich mit einem Gastkonto zu registrieren.',
    conflict: 'Bereits vorhanden.',
    forbidden:
      'Sie sind nicht berechtigt, diese Aktion durchzuführen. Bitte wenden Sie sich an Ihren Administrator, wenn Sie glauben, dass dies ein Fehler ist.',
    gatewayTimeout: 'Der Server hat nicht geantwortet, bitte versuchen Sie es später noch einmal.',
    internalServerError:
      'Es ist ein interner Serverfehler aufgetreten. Bitte versuchen Sie es später noch einmal.',
    sessionExpired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    unknownError: 'Ein unbekannter Fehler ist aufgetreten',
    unauthorized: {
      common: 'Ein unbekannter Autorisierungsfehler ist aufgetreten',
      invalid_client: 'Bad client credentials',
    },
    validationErrors: {
      missing: {
        card_cardType: 'The selected credit card is not supported. Please select another.',
        card_accountNumber: 'The credit card number entered is not valid.',
        card_cvNumber: 'The security code entered is not valid.',
        card_expirationMonth: 'The credit card expiration date entered is not valid.',
        card_expirationYear: 'The credit card expiration date entered is not valid.',
        billTo_firstName: 'The first name entered is not valid.',
        billTo_lastName: 'The last name entered is not valid.',
        billTo_street1: 'The address entered is not valid.',
        billTo_street2: 'The address entered is not valid.',
        billTo_city: 'The city entered is not valid for this credit card.',
        billTo_state: 'The state/province entered is not valid for this credit card.',
        billTo_country: 'The country/region entered is not valid for this credit card.',
        billTo_postalCode: 'The zip/postal code is not valid for this credit card.',
        country: {
          isocode: 'Missing country/region',
        },
      },
      invalid: {
        card_expirationMonth: 'Das eingegebene Ablaufdatum der Kreditkarte ist nicht gültig.',
        firstName: 'Der eingegebene Vorname ist nicht gültig.',
        lastName: 'Der eingegebene Nachname ist nicht gültig.',
        password: 'Das eingegebene Passwort ist ungültig.',
        uid: 'E-Mail ist nicht gültig.',
        code: 'Code ist nicht gültig.',
        email: 'Email ist nicht gültig.',
        login: 'Email ist nicht gültig.',
      },
    },
    cartNotFound: 'Warenkorb nicht gefunden.',
    invalidCodeProvided: 'Ungültiger Code angegeben.',
  },
  miniCart: {
    item: '{{count}} Artikel in deinem Warenkorb',
    item_plural: '{{count}} Artikel in deinem Warenkorb',
    total: '{{total}}',
    count: '{{count}}',
  },
  skipLink: {
    skipTo: 'Skip to',
    labels: {
      header: 'Header',
      main: 'Main Content',
      footer: 'Footer',
      productFacets: 'Product Facets',
      productList: 'Product List',
    },
  },
  formErrors: {
    globalMessage: 'The form you are trying to submit contains errors.',
    required: 'Pflichtfeld',
    maxLength40: 'Das Feld ist begrenzt auf 40 Zeichen.',
    cxInvalidEmail: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    cxInvalidPassword: 'This is not a valid password format',
    cxPasswordsMustMatch: 'Password fields must match',
    cxEmailsMustMatch: 'Email fields must match',
    cxStarRatingEmpty: 'Rating field is required',
    cxNoSelectedItemToCancel: 'Select at least one item',
    cxNegativeAmount: 'Amount must be equal or greater than zero',
    cxContainsSpecialCharacters: 'Field cannot contain special characters',
    date: {
      required: 'This field is required',
      min: 'Date cannot be before {{min}}',
      max: 'Date cannot be after {{max}}',
      pattern: 'Use dateformat yyyy-mm-dd',
      invalid: 'Use a valid date',
    },
  },
  errorHandlers: {
    scriptFailedToLoad: 'Failed to load the script.',
    refreshThePage: 'Please refresh the page.',
  },
};
